var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-combobox',_vm._b({attrs:{"items":_vm.states,"label":"Bundesland"},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}},'v-combobox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }